<?xml version="1.0" encoding="UTF-8"?>
<svg width="18px" height="14px" viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M0.201269535,13.8929231 C9.44743109,5.03509764 14.0705119,0.606184889 14.0705119,0.606184889 C14.0705119,0.606184889 15.2227128,0.606184889 17.5271147,0.606184889 L4.24595866,13.8929231 L0.201269535,13.8929231 Z" id="Path-2" fill="#FF63AF"></path>
    </g>
</svg>